/**
 * Dialog: mover factura individual a otra nómina, viernes o fecha custom.
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos).
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { DatePickerInput } from '../../ui/date-picker';
import { Calendar } from 'lucide-react';
import { toast } from '../../../hooks/use-toast';

const fmt = (n) => `$${Math.round(n || 0).toLocaleString('es-CL')}`;
const fmtFecha = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso + 'T12:00:00');
  return d.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
};

export function MoverFacturaDialog({
  open,
  factura,
  nominas,
  proximosViernes,
  fechaCustom,
  setFechaCustom,
  onClose,
  onMover,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="dialog-mover">
        <DialogHeader>
          <DialogTitle>Mover factura a otra nómina</DialogTitle>
        </DialogHeader>
        {factura && (
          <div className="space-y-3">
            <div className="text-xs text-muted-foreground">
              <b>{factura.nombre_proveedor}</b> · Folio {factura.folio} · {fmt(factura.monto)}
            </div>

            <div>
              <Label className="text-xs">Próximos viernes</Label>
              <div className="grid grid-cols-2 gap-1.5 mt-1">
                {proximosViernes.map((v) => (
                  <Button
                    key={v.iso}
                    size="sm"
                    variant="outline"
                    className="text-xs justify-start gap-1 h-8"
                    onClick={() => onMover(null, v.iso)}
                    data-testid={`btn-prox-vie-${v.iso}`}
                  >
                    <Calendar className="h-3 w-3" />
                    <span className="font-medium">{v.label}</span>
                    <span className="text-[10px] text-muted-foreground">+{v.deltaDays}d</span>
                  </Button>
                ))}
              </div>
              <p className="text-[10px] text-muted-foreground mt-1">
                Si Alegra recibe el pago antes, se marcará pagada automáticamente (sync horario).
              </p>
            </div>

            <div className="text-center text-xs text-muted-foreground">
              o seleccionar nómina existente
            </div>
            <div>
              <Select onValueChange={(v) => onMover(v, null)}>
                <SelectTrigger>
                  <SelectValue placeholder="-- Elegir nómina --" />
                </SelectTrigger>
                <SelectContent>
                  {nominas.map((n) => (
                    <SelectItem key={n.id} value={n.id}>
                      {n.nombre} · {fmtFecha(n.fecha_pago)} ({n.num_facturas} fact.)
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="text-center text-xs text-muted-foreground">o fecha custom</div>
            <div className="flex gap-2">
              <div className="flex-1">
                <DatePickerInput
                  value={fechaCustom}
                  onChange={setFechaCustom}
                  data-testid="datepicker-mover-fecha"
                />
              </div>
              <Button
                size="sm"
                onClick={() => {
                  if (!fechaCustom) {
                    toast({ title: 'Indique una fecha', variant: 'destructive' });
                    return;
                  }
                  onMover(null, fechaCustom);
                  setFechaCustom('');
                }}
              >
                Crear y mover
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
